<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {computed} from "vue";

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  usingGlobalStyling: { // used to use newer styling when embedding this via ai-onboarding flow
    type: Boolean,
    required: false,
    default: false,
  },
});

const modalClasses = computed(() => {
  return props.usingGlobalStyling
    ? 'tw-max-w-[800px] tw-text-base'
    : ''
});

const emit = defineEmits(['cancel', 'confirm']);
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      :modal-class="modalClasses"
      @close="emit('cancel')"
    >
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-8 tw-pb-8">
        <h2 class="tw-mb-2 tw-text-2.5xl tw-font-bold tw-text-grey-dark">
          Before you go…
        </h2>

        <p class="tw-mb-2">
          Please confirm that the information that you have provided is correct, to the best of your knowledge.
        </p>

        <p class="tw-mb-12">
          If incorrect this can cause a delay in the installation and starting your SEO.
        </p>

        <div
          v-if="usingGlobalStyling"
          class="tw-flex tw-items-center tw-justify-end tw-gap-4"
        >
          <DefaultButton
            variant="primary-inverted"
            :disabled="loading"
            @click.prevent="emit('cancel')"
          >
            Cancel
          </DefaultButton>

          <DefaultButton
            :loading="loading"
            :disabled="loading"
            @click.prevent="emit('confirm')"
          >
            Confirm
          </DefaultButton>
        </div>

        <div
          v-else
          class="tw-flex tw-items-center tw-justify-end tw-gap-4"
        >
          <DefaultButton
            variant="base"
            :disabled="loading"
            @click.prevent="emit('cancel')"
          >
            Cancel
          </DefaultButton>

          <DefaultButton
            variant="everest"
            :loading="loading"
            :disabled="loading"
            @click.prevent="emit('confirm')"
          >
            Confirm
          </DefaultButton>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>
